/* eslint-disable camelcase */
import axios from 'axios';
import { origin } from './config';

axios.defaults.baseURL = origin;

export { default as authRequest } from './auth';
export { pagableRequest, request } from './request';
